import { takeEvery, put, call, all, fork } from "@redux-saga/core/effects";
import { FETCH_TENANT } from "redux/constants/flowDesigner";
import { setTenant } from "redux/actions/flowDesigner/tenantActionCreator";
import { getTenantDataById } from "api/tenantApi";

function* handleFetchTenant({ payload }) {
   try {
      const { tenant_id } = payload;

      const res = yield call(getTenantDataById, tenant_id);
      if (res) {
         yield put(setTenant(res));
      }
   } catch (error) {
      console.error("handleFetchTenant error: ", error);
   }
}

/***** WATCHERS *****/

function* watchFetchTenant() {
   yield takeEvery(FETCH_TENANT, handleFetchTenant);
}

export function* rootTenantSaga() {
   yield all([fork(watchFetchTenant)]);
}
